import {
  FINANCIALRESPONSIBILITYPROGRAM_TABLE,
  GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_PENDING,
  GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_FULFILLED,
  GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_REJECTED,
  GET_FINANCIALRESPONSIBILITYPROGRAM_PENDING,
  GET_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED,
  GET_FINANCIALRESPONSIBILITYPROGRAM_REJECTED,
  DELETE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED,
  DELETE_FINANCIALRESPONSIBILITYPROGRAM_PENDING,
  ADD_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED,
  UPDATE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED
} from '../../actions/action-constants';
const initialState = {
  title: 'Financial Responsibility Programs',
  tablename: FINANCIALRESPONSIBILITYPROGRAM_TABLE,
  financialresponsibilityprograms: [],
  loadingList: false,
  errors: []
};
const reducerFinancialResponsibilityPrograms = (
  state = initialState,
  action
) => {
  var dataUndefinedTestReturn;
  switch (action.type) {
    case GET_FINANCIALRESPONSIBILITYPROGRAM_PENDING:
    case GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_PENDING:
    case DELETE_FINANCIALRESPONSIBILITYPROGRAM_PENDING:
      state = {
        ...state,
        loadingList: true
      };
      break;
    case GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : [];
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        financialresponsibilityprograms: dataUndefinedTestReturn
      };
      break;
    case GET_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : [];
      state = {
        ...state,
        loadingList: false,
        financialresponsibilityprograms: dataUndefinedTestReturn
      };
      break;
    case DELETE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      };
      break;
    case ADD_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      };
      break;
    case UPDATE_FINANCIALRESPONSIBILITYPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      };
      break;
    case GET_FINANCIALRESPONSIBILITYPROGRAM_LIST_REJECTED:
    case GET_FINANCIALRESPONSIBILITYPROGRAM_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      };
      break;
    default:
      return state;
  }
  return state;
};
export default reducerFinancialResponsibilityPrograms;
